import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { request } from "@/utils/api";

// Async thunk for fetching customer COD dues
export const fetchCustomerCODDues = createAsyncThunk(
    "customerDue/fetch",
    async ({ userId }, { rejectWithValue }) => {
        try {
            const response = await request({
                endpoint: "/admin/customer/getCustomerCODDues",
                method: "GET",
                params: { userId },
            });

            if (!response.data) {
                console.error("Invalid API response: No data field found.");
                return rejectWithValue("Invalid API response: No data field found.");
            }

            if (!response.data.COD) {
                console.error("Invalid API response: COD field missing.");
                return rejectWithValue("Invalid API response: COD field missing.");
            }

            if (!Array.isArray(response.data.COD)) {
                console.warn("COD field is not an array. Converting it.");
                return response.data.COD ? [response.data.COD] : [];
            }

            return response.data;
        } catch (error) {
            console.error("Error fetching customer COD dues:", error.message);
            return rejectWithValue(error.message || "An unexpected error occurred.");
        }
    }
);

const initialState = {
    customerCODDues: [], // Array to store all customer COD dues
    loading: false,
    error: null,
};

const customerDueSlice = createSlice({
    name: "customerDue",
    initialState,
    reducers: {
        addCustomerCODDues: (state, action) => {
            state.customerCODDues = action.payload;
        },
        clearCustomerCODDues: (state) => {
            state.customerCODDues = [];
            state.loading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCustomerCODDues.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCustomerCODDues.fulfilled, (state, action) => {
                state.loading = false;
                state.customerCODDues = action.payload; // Update the customer COD dues array
            })
            .addCase(fetchCustomerCODDues.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload; // Store the error message
            });
    },
});

export const { clearCustomerCODDues, addCustomerCODDues } = customerDueSlice.actions;
export default customerDueSlice.reducer;
